module.exports = __webpack_public_path__ + "static/media/inbound_icon.0f1b44d7.svg";